/**
 * @file 平台类(ios, android)处理方法
 */
export default {
    /**
     * 判断当前系统是否为iOS9以上(包括iOS9)
     *
     * @private
     * @return  {boolean}
     */
    isIos9: () => {
        if ((navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPod/i))) {
            const version = navigator.userAgent.replace(/^.*OS ([\d_]+) like.*$/, '$1');
            return parseInt(version.split('_')[0], 10) > 8;
        }
        return false;
    },

    /**
     * 判断是否为iOS
     *
     * @private
     * @return  {boolean}
     */
    isIos: () => /iphone|ipad|ipod/i.test(navigator.userAgent),

    /**
     * 判断是否为Android
     *
     * @private
     * @return  {boolean}
     */
    isAndroid: () => /android/i.test(navigator.userAgent)
};
